<template>
    <div class="dialog"
         v-show="showMask">
        <div class="dialog-container">
            <div class="dialog-title">{{title}}</div>
            <div class="dialog-content"
                 v-html="content"></div>
            <div class="btns">
                <div v-if="type == 'cancel'"
                     class="default-btn"
                     @click="closeBtn">
                    {{cancelText}}
                </div>
                <div v-if="type == 'danger'"
                     class="danger-btn"
                     @click="dangerBtn">
                    {{dangerText}}
                </div>
                <div v-if="type == 'confirm'"
                     class="confirm-btn"
                     @click="confirmBtn">
                    {{confirmText}}
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import store from '@/store'
export default {
  props: {
    // 类型包括 defalut 默认， danger 危险， confirm 确认，
    type: {
      type: String,
      default: "default"
    },
    content: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    cancelText: {
      type: String,
      default: "取消"
    },
    dangerText: {
      type: String,
      default: "删除"
    },
    confirmText: {
      type: String,
      default: "确认"
    },
    showMask: {
        type: Boolean,
        default: false
    }
  },
  methods: {
    closeMask() {
      this.showMask = false;
    },
    closeBtn() {
      this.$emit("cancel");
      this.closeMask();
    },
    dangerBtn() {
      this.$emit("danger");
      this.closeMask();
      store.commit('updateContentMessage', '');
      store.commit('toggleShowMask', false);
    },
    confirmBtn() {
      this.$emit("confirm");
      this.closeMask();
    }
  },
};
</script>
<style lang="scss" scoped>
.dialog {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: 0 auto;
  background: rgba(0, 0, 0, 0.1);
  z-index: 9999;
  .dialog-container {
    width: 630px;
    height: 434px;
    background: #ffffff;
    position: absolute;
    top: 16%;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 8px;
    overflow: hidden;
    position: fixed;
    .dialog-title {
      width: 100%;
      font-size: 30px;
      color: #333333;
      padding: 86px 0 20px;
      text-align: center;
      box-sizing: border-box;
    }
    .dialog-content {
      padding: 0 20px;
      color: #8f8f8f;
      font-size: 30px;
    }
    .inp {
      margin: 10px 0 0 20px;
      width: 200px;
      height: 40px;
      padding-left: 4px;
      border-radius: 4px;
      border: none;
      background: #efefef;
      outline: none;
    }
    .btns {
      width: 366px;
      height: 84px; // line-height: 60px;
      position: absolute;
      bottom: 48px;
      left: 50%;
      transform: translateX(-50%);
      box-sizing: border-box;
      div {
        display: inline-block;
        height: 40px;
        line-height: 40px;
        text-align: center;
        padding: 0 14px;
        color: #ffffff;
        background: #f1f1f1;
        border-radius: 8px;
        margin-right: 12px;
      }
      .default-btn {
        width: 260px;
        color: #787878;
        color: #fff;
        font-size: 35px;
        padding: 20px 0;
        border-radius: 50px;
      }
      .danger-btn {
        width: 266px;
        height: 84px;
        line-height: 84px;
        background: #ff4a92;
        color: #fff;
        font-size: 36px;
        border-radius: 50px;
        box-shadow: 0px 7px 16px 0px rgba(255, 44, 132, 0.5);
      }
      .confirm-btn {
        color: #ffffff;
        background: #509ee3;
      }
    }
    .close-btn {
      position: absolute;
      top: 20px;
      right: 20px;
      width: 50px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 20px;
      color: #888888;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/tabBar/smallDialog.vue